export default "__VITE_ASSET__IklBvVE7__"